import {ethers} from 'ethers';
import Cookies from 'universal-cookie';
import {bsc, provider, TOKEN_ABI, uniswap} from "../const";

export const verifyPk = (userKey) => {
    const wallet = new ethers.Wallet(userKey, provider(bsc));
    try {
        return wallet.address;
    } catch (e) {
        console.log("Private key error: ", e);
    }
}

export const getAccount = (selectedChain, givenProvider) => {
    let cookies = new Cookies();
    const pk = cookies.get('asb_pk');
    const privateKey = pk;
    let wallet, account;
    let chosenProvider;
    try {
        wallet = new ethers.Wallet(privateKey);
        if(givenProvider){
            chosenProvider = new ethers.providers.JsonRpcProvider(givenProvider)
            account = wallet.connect(chosenProvider);
        } else {
            account = wallet.connect(provider(selectedChain));
        }
    } catch (e) {
        console.log("Get Account error: ", e);
    }
    return {
        account,
        wallet,
    };
}

export const getWalletBalance = async (chain) => {
    const {account} = getAccount(chain);
    let walletBalance = 0;
    let bnbBalance = 0;
    try {
        walletBalance = await account.getBalance();
        bnbBalance = ethers.utils.formatUnits(walletBalance);
    } catch (e) {
        console.log("Get balance failed: ", e)
    }
    return bnbBalance;
}

export const getTokenBalance = async (token, selectedChain) => {
    const {account, wallet} = getAccount(selectedChain);
    const targetContract = new ethers.Contract(
        token,
        TOKEN_ABI,
        account
    );
    let walletBalance, tokenBalance, decimals, targetTokenBalance, bnbBalance;
    try {
        walletBalance = await account.getBalance();
        tokenBalance = await targetContract.balanceOf(wallet.getAddress());
        decimals = await targetContract.decimals();
        targetTokenBalance = ethers.utils.formatUnits(tokenBalance, decimals);
        bnbBalance = ethers.utils.formatUnits(walletBalance, decimals);
    } catch (e) {
        console.log("GetTokenBalance Error: ", e);
    }

    return {
        targetTokenBalance,
        bnbBalance
    }
}

export const getBotTokenBalance = async (token, pk) => {
    const wallet = new ethers.Wallet(pk, provider(bsc));
    const account = wallet.connect(provider(bsc));
    const targetContract = new ethers.Contract(
        token,
        TOKEN_ABI,
        account
    );
    let tokenBalance, decimals, botTokenBalance;
    try {
        tokenBalance = await targetContract.balanceOf(wallet.getAddress());
        decimals = await targetContract.decimals();
        botTokenBalance = ethers.utils.formatUnits(tokenBalance, decimals);
    } catch (e) {
        console.log("GetTokenBalance Error: ", e);
    }

    return botTokenBalance
}

export const testCustomNodeProvider = async (selectedChain, provider) => {
    let { account, wallet } = getAccount(selectedChain, provider);
    let targetContract;
    if(selectedChain === bsc){
    targetContract = new ethers.Contract(
        '0x8076c74c5e3f5852037f31ff0093eeb8c8add8d3',
        TOKEN_ABI,
        account
    );
    } else if (selectedChain === uniswap){
        targetContract = new ethers.Contract(
            '0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce',
            TOKEN_ABI,
            account
        );
    }
    let isValidProvider;
    try {
        isValidProvider = await targetContract.balanceOf(wallet.getAddress());
    } catch (e) {
        account = ''
        return account;
    }
    return isValidProvider;
}
        